import * as _ from 'lodash';
import * as status from 'http-status';
import * as Bluebird from 'bluebird';
import { I18n, loadTranslations, setLocale } from 'react-redux-i18n-lite';
import * as shared from '../shared';
import {
  authTokenStorageHandler,
  getConfigurationFromStorage,
  getRefreshTokenFromStorage,
  getTokenFromStorage,
  refreshTokenStorageHandler,
  removeAuthenticationMethod,
  removeAuthTokenFromStorage,
  removeBooksFromStorage,
  removeLtiParamsFromStorage,
  removeRefreshTokenFromStorage
} from '../shared';
import { ASSET_TYPES, CLASSROOM_MODES, ERROR, ROUTES } from '../const';
import { isFetching } from './componentActions';
import { getDefaultLanguage, translationsObject } from '../services/translate/translateService';
import routerHistory from '../routerHistory';
import * as userApi from '../services/api/userApi';
import * as authApi from '../services/api/authApi';
import * as schoolActions from './schoolActions';
import * as connectionActions from './connectionActions';
import * as jwtService from '../services/jwt/jwtService';
import * as assetsService from '../services/assets/assetsService';
import { REDUCER } from '../reducers/reducersConst';
import * as backofficeApi from '../services/api/backofficeApi';
import { ApiLoaderService } from '../services/apiLoader/apiLoaderService';
import { diff } from '../utils/objectUtils';
import { getLogger } from '../services/logger';
import * as messageAlert from './messageAlertAction';
import {
  addRequestTokenSubscribersCallback,
  getRequestTokenSubscribersCallback
} from '../interceptors/responseService';
import { applySkin } from './skinActions';
import * as skinUtils from '../utils/skinUtils';
import * as socketSubscriber from '../services/socketConnection/socketSubscriberService';
import * as config from '../config_module';
import { reloadApp } from '../electron/windowManager';
import { isElectronApp, isEmbbededInTeams } from '../services/crossPlatform/crossPlatformService';
import { removeDiacritics } from '../utils/stringUtils';
import { setDayJsLocale } from '../services/translate/dayjsLocaleUpdater';
import url from 'url';
import {
  getAzureAccount,
  getLoginConfiguration,
  getMSALInstance,
  getTeamsToken,
  getTokenClaims
} from '../utils/azure/azureUtils';
import { loginInClassroomWithAzure } from '../services/api/authApi';
import { redirect, removeQueryParam } from '../utils/HttpUtils';
const debug = getLogger('actions:account');
import jwt from 'jsonwebtoken';

let crossPlatformSpecialization;
export let configure = injectedCrossPlatformSpecialization => {
  crossPlatformSpecialization = injectedCrossPlatformSpecialization;
};

/**
 * Saves the user data on the store
 * @param user
 * @returns {{type: string, user: {}}}
 */
export let setUserData = (user = {}) => {
  return {
    type: REDUCER.ACCOUNT.SET_USER_DATA,
    user
  };
};

/**
 * Saves the user data on the store
 * @param language
 * @returns {{type: string, user: {}}}
 */
export let setUserLanguage = language => {
  return {
    type: REDUCER.ACCOUNT.SET_USER_LANGUAGE,
    language
  };
};

export let setUpdatedUser = (updatedUser = {}) => {
  return {
    type: REDUCER.ACCOUNT.SET_UPDATED_USER,
    updatedUser
  };
};

export let setUserPicture = (picture = {}) => {
  return {
    type: REDUCER.ACCOUNT.SET_USER_PICTURE,
    picture: picture
  };
};

/**
 * Introduce el rol del usuario en el store durante el registro
 * @param role
 * @returns {{type: string, role: string}}
 */
export let setSignUpRole = (role = '') => {
  return {
    type: REDUCER.SIGNUP.SET_USER_ROLE,
    role
  };
};

/**
 * Introduce el mensaje de error en el store
 * @param formError
 * @returns {{type: string, formError: string}}
 */
export let setFormError = (formError = '') => {
  return {
    type: REDUCER.SIGNUP.SET_FORM_ERROR,
    formError
  };
};

export let setIndexTransition = (indexTransition = false) => {
  return {
    type: REDUCER.ROUTE.SET_INDEX_TRANSITION,
    indexTransition
  };
};

/**
 * Sets the app location at the store
 * @param location
 * @returns {{type: string, location: *}}
 */
export let setApplicationLocation = location => {
  return {
    type: REDUCER.ROUTE.SET_APP_LOCATION,
    location
  };
};

/**
 * Sets the app location at the store
 * @param params
 * @returns {{type: string, location: *}}
 */
export let setApplicationParams = params => {
  return {
    type: REDUCER.ROUTE.SET_APP_PARAMS,
    params
  };
};

/**
 * Sets the app location at the store
 * @param history
 * @returns {{type: string, location: *}}
 */
export let setApplicationHistory = history => {
  return {
    type: REDUCER.ROUTE.SET_APP_HISTORY,
    history
  };
};

export let setRedirectAfterLogin = redirectAfterLogin => {
  return {
    type: REDUCER.ROUTE.SET_REDIRECT_AFTER_LOGIN,
    redirectAfterLogin
  };
};

export let clearRedirectAfterLogin = () => {
  return {
    type: REDUCER.ROUTE.CLEAR_REDIRECT_AFTER_LOGIN
  };
};

/**
 * Logout del sistema
 * @returns {{type: string}}
 */
export let setLogout = () => {
  return {
    type: REDUCER.ACCOUNT.LOGOUT
  };
};

/**
 * Guardar en el store el estado de la petición de envío de contraseña
 * @param done
 * @returns {{type: string, done: boolean}}
 */
export let newPasswordSent = (done = true) => {
  return {
    type: REDUCER.ACCOUNT.NEW_PASSWORD_SENT,
    done
  };
};

/**
 * Guardar en el store el estado de la petición de envío de contraseña
 * @param configuration
 * @returns {{type: string, done: boolean}}
 */
export let setAccountConfiguration = (configuration = {}) => {
  return {
    type: REDUCER.ACCOUNT.CONFIGURATION,
    configuration
  };
};

/**
 *
 * @param configuration
 * @returns {{type: string, done: boolean}}
 */
export let setUserConfiguration = (configuration = {}) => {
  return {
    type: REDUCER.ACCOUNT.USER_CONFIGURATION,
    configuration
  };
};

/**
 *
 * @param newUserData
 * @returns {{type: *, newUserData: {}}}
 */
export let setNewUserData = (newUserData = {}) => {
  return {
    type: REDUCER.ACCOUNT.SET_NEW_USER_DATA,
    newUserData
  };
};

export let setRefreshModalState = (refreshModalIsOpen = false) => {
  return {
    type: REDUCER.ACCOUNT.SET_REFRESH_MODAL_STATE,
    refreshModalIsOpen
  };
};

export let setIsAlreadyFetchingToken = (isAlreadyFetchingToken = false) => {
  return {
    type: REDUCER.ACCOUNT.SET_IS_ALREADY_FETCHING_TOKEN,
    isAlreadyFetchingToken
  };
};
export const setJailed = (jailed = false) => {
  return {
    type: REDUCER.ACCOUNT.SET_JAILED,
    jailed
  };
};
export let refreshToken = () => {
  return dispatch => {
    let refreshTokenFromStorage = getRefreshTokenFromStorage();
    dispatch(setRefreshModalState(false));

    authApi
      .refreshToken(refreshTokenFromStorage)
      .then(res => {
        const { data } = res;
        authTokenStorageHandler(data.token);
        refreshTokenStorageHandler(data.refreshToken);
        crossPlatformSpecialization.sendExpiredTokenNotification(false);
        dispatch(onTokenFetched());
        if (checkAuthorization) {
          dispatch(checkAuthorization(data.token));
        }
      })
      .catch(error => {
        debug.error('error refreshing token: %s', error);
        dispatch(setRefreshModalState(false));
        dispatch(logout());
      });
  };
};

export let checkAuthorization = token => {
  return (dispatch, getState) => {
    const userId = jwtService.getUserIdByToken(token);
    const schoolId = jwtService.getSchoolId(token);
    backofficeApi.checkAuthorization(userId, schoolId);
  };
};

export let onTokenFetched = () => {
  return dispatch => {
    dispatch(setIsAlreadyFetchingToken(false));
    const subscribers = getRequestTokenSubscribersCallback();
    subscribers.filter(callback => callback());
  };
};

/* API CALLS ******************************/

/**
 * User login
 * @param email
 * @param password
 * @param alternativeUrl
 * @returns {function(*,*)}
 */
export let login = (email = '', password = '', alternativeUrl = null) => {
  return dispatch => {
    dispatch(isFetching(true));
    return authApi
      .login(email, password, alternativeUrl)
      .then(async res => {
        const { data } = res;

        if (!jwtService.isValidUserObject(data.token)) {
          dispatch(messageAlert.error(I18n.t('login.invalidToken')));
          throw new Error();
        }

        authTokenStorageHandler(data.token);
        refreshTokenStorageHandler(data.refreshToken);
        dispatch(isFetching(false));
        dispatch(connectionActions.loadAllDataOfApis());

        return jwtService.getUserIdByToken(data.token);
      })
      .catch(error => {
        dispatch(isFetching(false));
        return error;
      });
  };
};

export let forceCheckAndRefreshToken = callback => {
  return (dispatch, getState) => {
    let config = getState().account.configuration;
    const isAppOnline = getState().connection.status.online;

    if (!isAppOnline) {
      callback();
      return;
    }

    const token = getTokenFromStorage();
    if (token && jwtService.hasExpired(token)) {
      let isAlreadyFetchingAccessToken = getState().account.isAlreadyFetchingToken;
      if (!isAlreadyFetchingAccessToken) {
        dispatch(setIsAlreadyFetchingToken(true));

        if (callback) {
          addRequestTokenSubscribersCallback(callback);
        }

        const timeExpired = jwtService.timeExpiredInMinutes(token);
        if (timeExpired < config.inactivityTime) {
          dispatch(refreshToken());
        } else {
          crossPlatformSpecialization.sendExpiredTokenNotification(true);
          dispatch(setRefreshModalState(true));
        }
      } else if (callback) {
        addRequestTokenSubscribersCallback(callback);
      }
    } else if (callback) {
      callback();
    }
  };
};

export let redirectToHomeOrClassroom = (userId, homeRoute) => {
  return (dispatch, getState) => {
    dispatch(isFetching(true));
    if (userId) {
      const activeClassrooms = getState().classrooms.activeClassrooms;
      dispatch(isFetching(false));
      if (
        activeClassrooms.length === 1 ||
        (activeClassrooms.length >= 1 && !getState().account.configuration.enableHomeView)
      ) {
        return routerHistory.push(`${ROUTES.CLASSROOM}/${activeClassrooms[0].id}`);
      }
      const selectedClassroom = getState().router.params.idClassroom;
      return routerHistory.push(homeRoute ? homeRoute : `${ROUTES.CLASSROOM}/${selectedClassroom}`);
    }
    routerHistory.push(homeRoute);
  };
};

export let redirectToDiscussionsList = () => {
  return (dispatch, getState) => {
    const selectedClassroom = getState().router.params.idClassroom;
    if (selectedClassroom) {
      return routerHistory.push(`${ROUTES.CLASSROOM}/${selectedClassroom}/discussions`);
    }
  };
};

/**
 * Recupera la información del usuario
 * @returns {function(*, *)}
 */
export let getUserData = () => {
  return (dispatch, getState) => {
    let store = getState();
    let userId = jwtService.getUserId(store);
    let language = store.i18n.locale || store.account.user.language;

    return userApi
      .getUser(userId)
      .then(userRes => {
        const user = userRes.data;
        user.picture = `${config.BACKEND_URL}/api/v1/users/${user._id}/picture`;
        shared.setUserDataFromStorage(JSON.stringify(user));
        if (!_.isEqual(language, user.language)) {
          dispatch(setLocale(user.language));
          setDayJsLocale(user.language);
        }
        dispatch(setUserData(user));
        dispatch(schoolActions.getSchoolInfo());

        return user;
      })
      .catch(err => {
        if (err.response) {
          if (err.response.status === 403) {
            debug(I18n.t('api.error.backOffice.licenseExpired'));
          }
          if (err.response.status === 404) {
            debug(I18n.t('api.error.user.notFound'));
          }
          localStorage.setItem('error', err.response.status);
          dispatch(logout());
          return;
        }
        // No se pudo obtener la información del usuario. Se da por válida la school vacía.
        dispatch(schoolActions.setLoadedSchoolInfo());
      });
  };
};

/**
 * Recupera la configuracion de cliente
 * @returns {function(*, *)}
 */
export let getCostumerConfiguration = () => {
  return (dispatch, getState) => {
    const token = getTokenFromStorage();
    if (token && token.length !== 0) {
      let customerId = jwtService.getUserCustomerId(token);
      let schoolId = jwtService.getSchoolId(token);
      return backofficeApi.getCustomerConfiguration(customerId, schoolId).then(res => {
        let config = res.data;
        shared.setConfigurationFromStorage(JSON.stringify(config));
        dispatch(setAccountConfiguration(config));
        if (CLASSROOM_MODES.CORPORATE === config.classroomMode) {
          dispatch(loadTranslations(translationsObject(CLASSROOM_MODES.CORPORATE)));
        }
        return config;
      });
    } else {
      const store = getState();
      const redirectAfterLogin = url.format({
        pathname: store.router.location.pathname,
        search: store.router.location.search,
        hash: store.router.location.hash
      });
      dispatch(setRedirectAfterLogin(redirectAfterLogin));
      routerHistory.push(ROUTES.LOGINAUTH);
    }
  };
};

/**
 * Recupera la configuracion de usuario
 * @returns {function(*, *)}
 */
export let getUserConfiguration = () => {
  return (dispatch, getState) => {
    let store = getState();
    let userId = jwtService.getUserId(store);
    return userApi.getUserConfiguration(userId);
  };
};

/**
 * Recupera la configuracion de usuario y la guarda en el store
 * @returns {function(*, *)}
 */
export let loadUserConfiguration = () => {
  return (dispatch, getState) => {
    let store = getState();
    let userId = jwtService.getUserId(store);
    if (!userId) {
      return Promise.resolve();
    }
    return userApi.getUserConfiguration(userId).then(configuration => {
      if (configuration) {
        dispatch(setUserConfiguration(configuration));
      }
      return configuration;
    });
  };
};

/**
 * Makes a login with user's google data
 * @param googleData
 * @returns {function(*, *)}
 */
export let loginGoogle = (googleData = {}) => {
  return dispatch => {
    dispatch(isFetching(true));
    return authApi
      .loginGoogle(googleData.email, googleData.accessToken)
      .then(res => {
        const { token, refreshToken } = res.data;

        authTokenStorageHandler(token);
        refreshTokenStorageHandler(refreshToken);
        dispatch(isFetching(false));
        dispatch(connectionActions.loadAllDataOfApis());

        return jwtService.getUserIdByToken(token);
      })
      .catch(error => {
        if (
          error.response &&
          error.response.status === status.NOT_FOUND &&
          error.response.data.code === ERROR.NOT_FOUND_GOOGLE.code
        ) {
          dispatch(setUserData(googleData));
          routerHistory.push(ROUTES.JOIN_GOOGLE);
        }
        dispatch(isFetching(false));
        throw error;
      });
  };
};

export let loginAzure = redirectUrl => {
  return (dispatch, getState) => {
    const isTeamsContext = isEmbbededInTeams();
    let account = null;

    try {
      account = getAzureAccount();
    } catch (e) {
      console.info('No account found');
    }

    if (isTeamsContext) {
      authenticateTeams(dispatch, getState, redirectUrl);
      return;
    }

    if (!account) {
      getMSALInstance()
        .loginPopup(getLoginConfiguration())
        .then(() => {
          authenticateAzure(dispatch, getState, redirectUrl);
        })
        .catch(error => {
          console.error(error);
          removeAuthenticationMethod();
          routerHistory.push(ROUTES.LOGINAUTH);
        });
    } else {
      authenticateAzure(dispatch, getState, redirectUrl);
    }
  };
};

const authenticateAzure = (dispatch, getState, redirectUrl) => {
  const account = getAzureAccount();
  getMSALInstance()
    .acquireTokenSilent(getTokenClaims())
    .then(tokenResponse => {
      const accessToken = tokenResponse.accessToken;

      loginInClassroomWithAzure(accessToken)
        .then(response => {
          const { token, refreshToken } = response.data;

          authTokenStorageHandler(token);
          refreshTokenStorageHandler(refreshToken);
          removeAuthenticationMethod();

          redirect(redirectUrl);
        })
        .catch(error => {
          if (error.response && error.response.status === status.NOT_FOUND) {
            dispatch(
              setUserData({
                email: account.username,
                userId: account.username,
                name: account.name.substring(0, account.name.indexOf(' ')),
                surname: account.name.substring(account.name.indexOf(' ') + 1),
                picture: getState().theme.images.avatars[Math.floor(Math.random() * 24) + 1],
                accessToken: tokenResponse.accessToken
              })
            );
            routerHistory.push(ROUTES.JOIN_AZURE);
          } else {
            console.error(error);
            removeAuthenticationMethod();
            routerHistory.push(ROUTES.LOGINAUTH);
          }
        });
    })
    .catch(error => {
      console.error(error);
      removeAuthenticationMethod();
      routerHistory.push(ROUTES.LOGINAUTH);
    });
};

const authenticateTeams = async (dispatch, getState, redirectUrl) => {
  const teamsToken = await getTeamsToken();

  loginInClassroomWithAzure(teamsToken)
    .then(response => {
      const { token, refreshToken } = response.data;

      authTokenStorageHandler(token);
      refreshTokenStorageHandler(refreshToken);
      removeAuthenticationMethod();

      redirect(redirectUrl);
    })
    .catch(error => {
      if (error.response && error.response.status === status.NOT_FOUND) {
        const decodedToken = jwt.decode(teamsToken);
        dispatch(
          setUserData({
            email: decodedToken.preferred_username,
            userId: decodedToken.preferred_username,
            name: decodedToken.name.substring(0, decodedToken.name.indexOf(' ')),
            surname: decodedToken.name.substring(decodedToken.name.indexOf(' ') + 1),
            picture: getState().theme.images.avatars[Math.floor(Math.random() * 24) + 1],
            accessToken: teamsToken
          })
        );
        routerHistory.push(ROUTES.JOIN_AZURE);
      } else {
        console.error(error);
        removeAuthenticationMethod();
        routerHistory.push(ROUTES.LOGINAUTH);
      }
    });
};

/**
 * Action para registro (sign-up) de un usuario
 * @param user
 * @returns {function(*, *)}
 */
export let signUp = (user = {}) => {
  return dispatch => {
    dispatch(isFetching(true));

    return userApi
      .signUp(user)
      .then(res => {
        return Bluebird.try(() => {
          const userCreated = res.data.user;

          dispatch(isFetching(false));
          dispatch(setUserData(userCreated));

          return dispatch(login(user.email, user.password));
        }).then(loginResponse => {
          return loginResponse;
        });
      })
      .catch(error => {
        dispatch(isFetching(false));
        throw error;
      });
  };
};

/**
 * Action to register (sign-up) a google user
 * @param googleUserData
 * @returns {function(*, *)}
 */
export let signUpWithGoogle = (googleUserData = {}) => {
  return dispatch => {
    dispatch(isFetching(true));
    googleUserData.language = getDefaultLanguage();

    return userApi
      .signUpWithGoogle(googleUserData)
      .then(res => {
        return Bluebird.try(() => {
          const userCreated = res.data.user;

          dispatch(isFetching(false));
          dispatch(setUserData(userCreated));

          return dispatch(loginGoogle(googleUserData));
        }).then(loginResponse => {
          return loginResponse;
        });
      })
      .catch(error => {
        dispatch(isFetching(false));
        throw error;
      });
  };
};

/**
 * Action to register (sign-up) an azure user
 * @param azureUserData
 * @returns {function(*, *)}
 */
export let signUpWithAzure = (azureUserData = {}) => {
  return dispatch => {
    dispatch(isFetching(true));
    azureUserData.language = getDefaultLanguage();

    return userApi
      .signUpWithAzure(azureUserData)
      .then(res => {
        return Bluebird.try(() => {
          const userCreated = res.data.user;

          dispatch(isFetching(false));
          dispatch(setUserData(userCreated));

          return dispatch(loginAzure());
        }).then(loginResponse => {
          return loginResponse;
        });
      })
      .catch(error => {
        dispatch(isFetching(false));
        throw error;
      });
  };
};

/**
 * Action para realizar una petición de una nueva contraseña
 * @param email
 * @returns {function(*, *)}
 */
export let requestNewPassword = (email = '') => {
  return dispatch => {
    dispatch(isFetching(true));
    return userApi
      .requestNewPassword(email)
      .then(res => {
        dispatch(newPasswordSent(true));
        dispatch(isFetching(false));
        return res;
      })
      .catch(err => {
        dispatch(newPasswordSent(false));
        dispatch(isFetching(false));
        return err;
      });
  };
};

/**
 * Updates the user password through a temporal token
 * @param newPassword
 * @param token
 * @returns {function(*)}
 */
export let resetPassword = (newPassword = '', token = '') => {
  return dispatch => {
    dispatch(isFetching(true));
    return userApi
      .resetPassword(newPassword, token)
      .then(res => {
        dispatch(isFetching(false));
        routerHistory.push(ROUTES.LOGIN);
        return res;
      })
      .catch(err => {
        dispatch(isFetching(false));
        return err;
      });
  };
};

/**
 * Updates the user data
 * @returns {function(*, *)}
 */
export let updateUserData = () => {
  return (dispatch, getState) => {
    let store = getState();
    let updateLoggedProfile = _.isNil(store.student.selectedStudent);
    let userId;
    let updatedData;
    const { userConfiguration, ...newUserDataWithoutConfiguration } = store.account.newUserData;
    if (updateLoggedProfile) {
      userId = jwtService.getUserId(store);
      updatedData = diff(store.account.user, newUserDataWithoutConfiguration);
    } else {
      userId = store.student.selectedStudentProfile._id;
      updatedData = diff(store.student.selectedStudentProfile, newUserDataWithoutConfiguration);
    }

    const updateData = user => {
      if (updateLoggedProfile) {
        dispatch(setUserData({ ...user }));
        dispatch(setLocale(user.language));
        setDayJsLocale(user.language);
      } else {
        dispatch(setUpdatedUser({ ...user }));
      }
    };

    const dataToUpdate = Object.assign(newUserDataWithoutConfiguration);
    const dataToRollback = Object.assign({}, store.account.user);
    let messageAlertSent = false;

    const picture = !isNaN(updatedData.picture)
      ? getState().theme.images.avatars[updatedData.picture]
      : updatedData.picture;

    if (updatedData.picture) {
      dataToUpdate.picture = picture;
      userApi
        .updateUserPicture(userId, {
          avatar: dataToUpdate.avatar,
          assetId: dataToUpdate.assetId,
          pictureType: dataToUpdate.pictureType
        })
        .then(() => {
          if (!messageAlertSent) {
            dispatch(messageAlert.success(I18n.t('userProfile.validForm')));
            messageAlertSent = true;
          }
        })
        .catch(error => {
          debug.error(error);
          dispatch(messageAlert.error(I18n.t('userProfile.formError')));
          dispatch(setUserPicture(dataToRollback.picture));
        });
    }

    updateData(dataToUpdate);
    delete updatedData.picture;
    delete updatedData.pictureType;
    delete updatedData.avatar;

    if (Object.keys(updatedData).length) {
      return userApi
        .updateUserData(userId, updatedData)
        .then(() => {
          if (!messageAlertSent) {
            dispatch(messageAlert.success(I18n.t('userProfile.validForm')));
            messageAlertSent = true;
          }
        })
        .catch(error => {
          debug.error(error);
          dispatch(messageAlert.error(I18n.t('userProfile.formError')));
          updateData(Object.assign({ picture: undefined }, dataToRollback));
        });
    }
  };
};

//----------------------------------------------------------------------------------------------------------------------
export let uploadUserAvatar = (image, user, customerId) => {
  return async dispatch => {
    let uploadAsset = '';
    const finalFileName = removeDiacritics(user.name);
    const assetMetadata = {
      fileName: finalFileName,
      customerId: customerId,
      assetType: ASSET_TYPES.USER_AVATAR
    };
    uploadAsset = await assetsService
      .uploadAsset(image, assetMetadata)
      .then(asset => {
        let newUser = _.cloneDeep(user);
        newUser.picture = asset.url;
        newUser.assetId = asset.uuid;
        newUser.pictureType = 'ASSET';
        dispatch(setNewUserData(newUser));
        return newUser;
      })
      .catch(err => {
        debug.error('[AccountActions] uploadUserAvatar %s', err);
        return err;
      });
    return uploadAsset;
  };
};

//----------------------------------------------------------------------------------------------------------------------
export let logout = () => {
  return (dispatch, getState) => {
    if (isElectronApp()) {
      removeBooksFromStorage();
      removeAuthTokenFromStorage();
      removeRefreshTokenFromStorage();
      removeLtiParamsFromStorage();
      reloadApp();
    } else {
      dispatch(setLogout());
      let userLanguage = getState().account.user.language;
      ApiLoaderService.getInstance().setLoadActivated(false);
      socketSubscriber.destroyConnection();
      removeAuthTokenFromStorage();
      removeRefreshTokenFromStorage();
      removeLtiParamsFromStorage();
      dispatch(setUserLanguage(userLanguage));
      const configFromLocalStorage = getConfigurationFromStorage();
      if (configFromLocalStorage) {
        const config = JSON.parse(configFromLocalStorage);
        dispatch(setAccountConfiguration(config));
      }
      dispatch(applySkin(skinUtils.getLastOrDefaultSkin()));
      dispatch(crossPlatformSpecialization.afterLogout());
      dispatch(setLocale(shared.getLanguageFromStorage() || getDefaultLanguage()));
      setDayJsLocale(getDefaultLanguage());
      dispatch(loadTranslations(translationsObject()));
    }
  };
};

//----------------------------------------------------------------------------------------------------------------------
export let deleteAccount = userId => {
  return dispatch => {
    return userApi
      .deleteUserData(userId)
      .then(res => {
        dispatch(logout());
        return res;
      })
      .catch(err => {
        return err;
      });
  };
};
